/**
 * useDealsTrend — динамика количества сделок воронки КОММА (Bitrix24, read-only).
 * Для графика «Динамика сделок» на Обзоре.
 */

import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/api/client';
import { type Period, periodQuery, periodKey } from '@/components/ui/PeriodPicker';

export interface DealsTrendPoint {
  date: string;
  deals: number;
  won: number;
}

export interface DealsTrendResponse {
  configured: boolean;
  period?: { from: string; to: string; days: number };
  trend?: DealsTrendPoint[];
  total?: number;
  won?: number;
}

export function useDealsTrend(period: Period) {
  return useQuery<DealsTrendResponse>({
    queryKey: ['crm', 'deals-trend', periodKey(period)],
    queryFn: () => apiFetch<DealsTrendResponse>(`/api/crm/deals-trend?${periodQuery(period)}`),
    staleTime: 120_000,
    placeholderData: keepPreviousData,
  });
}
